module.exports = __webpack_public_path__ + "static/media/logoPriorityHealth.d2b2190f.png";